"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_all_client_users = void 0;
var api_1 = require("../../api");
// export const get_all_client_users = (client_id: string) => {
//   return apiGet({
//     endpoint: `v3/user/users_for_client`,
//     query: {
//       client_entity_id: client_id,
//     },
//   });
// };
var get_all_client_users = function (client_id, pagination) {
    return (0, api_1.apiGet)({
        endpoint: "v3/user/users_for_client",
        query: __assign({ client_entity_id: client_id }, pagination),
    });
};
exports.get_all_client_users = get_all_client_users;
